export default __webpack_public_path__ + "static/media/Master.00a7671b.svg";